(() => {
  /**
   * Check if the url contains "region=" and/or "currency=" attributes
   * If it contains just "region=" they have used the region switcher to manually switch regions
   * If it contains just "currency=" they have used the currency switcher but stayed on the current site
   * If it contains both they have used the currency switcher and switched regions
   */
  const onDocumentReady = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const viaFeature = urlParams.get('via-feature');
    const currency = Shopify.currency.active.toLowerCase();
    const location = urlParams.get('location');
    const from = urlParams.get('from');

    if (viaFeature === 'currency-switcher' || viaFeature === 'region-switcher') {
      const data = {
        event: 'regionalisation',
        viaFeature: viaFeature,
        selection: viaFeature === 'currency-switcher' ? currency : location,
      };
      if (from) {
        data.from = from;
      }
      // console.log(data);
      window.dataLayer.push(data);
    }
  };

  /**
   * Check if the url contains "via-feature" === "see-similar" and if so add to dataLayer
   */
  const onPDPLoad = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('via-feature') === 'see-similar') {
      window.dataLayer = window.dataLayer || [];
      const data = {
        event: 'seeSimilarRecommendationClick',
        productTitle: window.product.title,
      };
      // console.log(data);
      window.dataLayer.push(data);
    }
  };

  /**
   * Track add to carts through dataLayer
   */
  const onAddToCart = (event) => {
    /**
     * If data-via is set on the variant selector we will send add to the dataLayer
     * which will be sent to analytics for reporting purposes
     */
    const viaData = [];
    const viaFeature = event && event.target.dataset && event.target.dataset.via;
    let viaFeatureAddToCartEvent;
    if (viaFeature) {
      viaFeatureAddToCartEvent =
        viaFeature.replace(/-./g, function (x) {
          return x[1].toUpperCase();
        }) + 'AddToCart';
    }

    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'addToCart',
      ecommerce: {
        currencyCode: Shopify.currency.active,
        add: {
          products: [],
        },
      },
    };
    event.detail.items.forEach((x) => {
      data.ecommerce.add.products.push({
        name: x.product_title,
        id: x.variant_id,
        productId: x.product_id,
        shopifyId: `shopify_US_${x.product_id}_${x.variant_id}`,
        price: x.price,
        brand: x.vendor.replace("'", ''),
        category: x.product_type,
        handle: x.handle,
        // model: model, // "model: value" tag on product
      });

      if (viaFeature) {
        viaData.push({
          event: viaFeatureAddToCartEvent,
          productTitle: x.product_title,
        });
      }
    });
    // console.log(event, data, ...viaData);
    window.dataLayer.push(data, ...viaData);
  };

  const onProductCardClick = (event) => {
    // console.log('onProductCardClick', event);

    const cardContext = event.detail.cardContext;
    const productData = event.detail.productData;
    const isCollectionCard = !!(cardContext === 'collection-list');
    const isSearchCard = !!(cardContext === 'search-results' || cardContext === 'search-suggestions');

    const isLinkToProductPage = event.detail.clickEvent.target.closest('product-card a');

    let list = '';
    if (isCollectionCard) {
      list = 'Collection Page';
    }
    if (isSearchCard) {
      list = 'Search Results';
    }

    if (!((isCollectionCard || isSearchCard) && isLinkToProductPage)) {
      return;
    }

    const data = {
      event: 'productClick',
      ecommerce: {
        currencyCode: Shopify.currency.active,
        click: {
          actionField: {
            list,
          },
          products: [
            {
              name: productData.title,
              id: productData.first_variant?.sku,
              productId: productData.id,
              shopifyId: `shopify_US_${productData.id}_${productData.first_variant?.id}`,
              price: productData.first_variant ? productData.first_variant.price / 100 : null,
              brand: productData.vendor?.replace("'", ''),
              category: productData.type,
              handle: productData.handle,
              model: productData.model,
            },
          ],
        },
      },
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };

  /**
   * Track impressions of product card in collection through dataLayer
   */
  const onProductCardView = (event) => {
    // console.log('onProductCardView', event);

    const cardContext = event.detail.cardContext;
    const productData = event.detail.productData;
    const isCollectionCard = !!(cardContext === 'collection-list');

    if (!isCollectionCard) {
      return;
    }

    const cardIndex = event.detail.cardIndex;

    const data = {
      event: 'collectionView',
      ecommerce: {
        currencyCode: Shopify.currency.active,
        actionField: {
          list: 'Collection Page',
        },
        impressions: [
          {
            name: productData.title,
            id: productData.first_variant?.sku,
            productId: productData.id,
            shopifyId: `shopify_US_${productData.id}_${productData.first_variant?.id}`,
            price: productData.first_variant ? productData.first_variant.price / 100 : null,
            brand: productData.vendor?.replace("'", ''),
            category: productData.type,
            handle: productData.handle,
            model: productData.model,
            position: cardIndex,
            list: 'Collection Page',
          },
        ],
      },
    };

    // console.log(data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };

  /**
   * Add to dataLayer which will be sent to analytics for reporting purposes
   */
  const onShippingCalcNoResults = (event) => {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'shippingCalculatorNoResults',
      postcode: event.detail.zip,
    };
    // console.log(event, data);
    window.dataLayer.push(data);
  };

  /**
   * Add to dataLayer which will be sent to analytics for reporting purposes
   */
  const onShippingCalcSuccess = (event) => {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'shippingCalculatorSuccess',
      postcode: event.detail.zip,
    };
    // console.log(event, data);
    window.dataLayer.push(data);
  };

  /**
   * Track clicks on the PDP sizing links (MSK-24, secondary metric for the
   * MSK-T001 A/B test). Matched via the modal each link opens rather than its
   * classes, so the events keep firing if the test variant restyles the links.
   */
  const onSizingLinkClick = (event) => {
    const opener = event.target.closest(
      'modal-opener[data-modal="#PopupModal-RecommendedSize"], modal-opener[data-modal="#PopupModal-SizeGuide"], .boldmetrics-vsizer, .boldmetrics-sizechart'
    );
    if (!opener) {
      return;
    }

    const isRecommendedSize =
      opener.matches('[data-modal="#PopupModal-RecommendedSize"], .boldmetrics-vsizer') ||
      !!opener.querySelector('.boldmetrics-vsizer');

    window.dataLayer = window.dataLayer || [];
    const data = {
      event: isRecommendedSize ? 'recommendedSizeClick' : 'sizeGuideClick',
      productTitle: window.product?.title,
    };
    // console.log(event, data);
    window.dataLayer.push(data);
  };

  const onWishlistAdd = (event) => {
    window.dataLayer = window.dataLayer || [];
    const data = [];
    for (const product of event.detail.products) {
      data.push({
        event: 'wishlistAdd',
        productTitle: product.title,
      });
    }
    // console.log(event, data);
    window.dataLayer.push(...data);
  };

  document.addEventListener('DOMContentLoaded', onDocumentReady);
  if (document.body.classList.contains('template-product')) {
    document.addEventListener('DOMContentLoaded', onPDPLoad);
  }

  document.addEventListener('add-to-cart', onAddToCart);
  document.addEventListener('product-card-click', onProductCardClick);
  document.addEventListener('product-card-view', onProductCardView);
  document.addEventListener('shipping-calc-noresults', onShippingCalcNoResults);
  document.addEventListener('shipping-calc-success', onShippingCalcSuccess);
  document.addEventListener('wishlist-add', onWishlistAdd);
  // Gate on the template name so alternate/Shoplift product templates
  // (template-product-sl-…) are included, not just the default template.
  if (document.body.dataset.templateName === 'product') {
    document.addEventListener('click', onSizingLinkClick);
  }
})();
